module.exports = __webpack_public_path__ + "img/eq-war-axe.b1c9b228.png";